import type { DesignTokens } from '@vibesites/tokens';
import { defaultTokens } from '@vibesites/tokens';

export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    primary: '#A0206E',
    secondary: '#4A8B7A',
    accent: '#5B7A8C',
    background: '#FFFFFF',
    surface: '#F5F5F5',
    text: '#1A1A1A',
    textMuted: '#666666',
    textOnPrimary: '#FFFFFF',
    textOnSecondary: '#FFFFFF',
    border: '#E0E0E0',
    error: '#dc2626',
    success: '#16a34a',
    warning: '#f59e0b',
  },
  font: {
    ...defaultTokens.font,
    heading: '"Lexend Deca", sans-serif',
    body: '"Source Sans Pro", "Roboto", sans-serif',
  },
  fontSize: {
    ...defaultTokens.fontSize,
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    '4xl': '2.5rem',
    '5xl': '3rem',
  },
  fontWeight: {
    ...defaultTokens.fontWeight,
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
  spacing: {
    ...defaultTokens.spacing,
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
  },
  radius: {
    ...defaultTokens.radius,
    sm: '0.125rem',
    md: '0.25rem',
    lg: '0.5rem',
    full: '9999px',
  },
  shadow: {
    ...defaultTokens.shadow,
    sm: '0 1px 2px rgba(52, 46, 31, 0.05)',
    md: '0 4px 6px rgba(52, 46, 31, 0.07)',
    lg: '0 10px 15px rgba(52, 46, 31, 0.1)',
  },
  transition: {
    ...defaultTokens.transition,
    fast: '150ms ease',
    normal: '300ms ease',
    slow: '500ms ease',
  },
};

export default tokens;
